export default __webpack_public_path__ + "static/media/WindsorBT.920421a9.ttf";